import React from 'react';
import TimeAgo from 'react-timeago';
import arabicStrings from 'react-timeago/lib/language-strings/ar';
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter';
import { Link, ResponsiveImage } from "@quintype/components";
import {format} from "date-fns";
import get from "lodash/get";

export function AuthorName({author, index, authorsLength, isLink}) {
  return <h3 className={`${isLink ? 'author__name--is-link' : ''} author__name`}>
    {index !== 0 && (index === authorsLength - 1 ? '&' : ',')} {author.name}
  </h3>
};

export function AuthorsNameList({ authors = [], authorsLength, isLink }) {
  const getLinkedAuthorName = (author = {}, index) => <Link href={`/author/${author.id}`} key={author.id}><AuthorName author={author} index={index} authorsLength={authorsLength} isLink/></Link>;

  return authors.map((author, index, authors) => isLink ? getLinkedAuthorName(author, index) : <AuthorName author={author} index={index} authorsLength={authorsLength} key={author.id}/>);
}

export function AuthorImage({'avatar-url':image, 'avatar-s3-key':imageS3, metadata = {}, name}) {
  if(imageS3) {
    return <div className="author__avatar">
      <ResponsiveImage slug={imageS3}
        metadata={metadata}
        aspectRatio={[1,1]}
        defaultWidth={48}
        imgParams={{auto: ['format','compress']}}
        alt={name}
      />
    </div>;
  }
  if(image) {
    return <div className="author__avatar">
      <img src={image} />
    </div>;
  }
  return null;
}

export function AuthorsImageList({ authors = [], isLink }) {
  const getLinkedAuthorImage = (author = {}) => <Link href={`/author/${author.id}`} key={author.id} className="author__avatar-wrapper--is-link"><AuthorImage {...author} /></Link>;

  return authors.map(author => isLink ? getLinkedAuthorImage(author) : <AuthorImage {...author} />);
}

export function FallbackAuthorImage() {
  // TODO: replace with a fallback image. and use it in AuthorImage component.
  return null;
}

export function formatter(value, unit, suffix, date, defaultFormatter, config = {}) {
  if(get(config, ['theme-attributes', 'lang']) === 'ar') {
    const _formatter =  buildFormatter(arabicStrings);
    return _formatter.apply(this, [value, unit, suffix, date]);
  }
  return format(new Date(date), 'DD MMM, YYYY [at] HH:mm A');
}

export function getAuthorNameKeyword() {
  return <span className="author-name-keyword">By </span>;
}

export function getStoryPubKeyword() {
  return <span className="pub-keyword">Published on : </span>;
}
